module.exports = __webpack_public_path__ + "img/public/siteImages/phoneNumber.svg?d788fedd";